export default __webpack_public_path__ + "static/media/card-m-about@2x.640ecaf6.png";